import { Action } from 'redux'
import { LimitActions } from '../../../reducers/userAccount/actionNames'

const toggleLimitModal = (toggle: boolean): IToggleLimitModal => ({
  toggle,
  type: LimitActions.ToggleLimitModal,
})

export interface IToggleLimitModal
  extends Action<LimitActions.ToggleLimitModal> {
  toggle: boolean
}

export default toggleLimitModal
